import React, { Dispatch, SetStateAction, useState } from "react";
import colors from "../../../utils/colors";
import Button from "../../../components/ui/button";
import { SetURLSearchParams } from "react-router-dom";
import { useResendOtp, useVerifyOtp } from "../../../apis/doctor";
import customToast, { ToastType } from "../../../components/Toast";
import { TDoctorInfo } from "../../../apis/types";

interface IProps {
  setStep: React.Dispatch<React.SetStateAction<string>>;
  setSearchParams: SetURLSearchParams;
  doctor: TDoctorInfo | undefined;
  setModalOpen: Dispatch<SetStateAction<boolean>>;
}
const EmailVerification = ({
  setStep,
  setSearchParams,
  doctor,
  setModalOpen,
}: IProps) => {
  const [otp1, setOtp1] = useState("");
  const [otp2, setOtp2] = useState("");
  const [otp3, setOtp3] = useState("");
  const [otp4, setOtp4] = useState("");
  const [otp5, setOtp5] = useState("");
  const [otp6, setOtp6] = useState("");
  const { mutate, isPending } = useVerifyOtp();
  const { mutate: resendOtp, isPending: isResending } = useResendOtp();

  const handleResendCode = () => {
    if (!doctor?._id) {
      customToast("Doctor information missing", ToastType.error);
      return;
    }

    resendOtp({ doctorId: doctor._id });

    // clear previous OTP fields
    setOtp1("");
    setOtp2("");
    setOtp3("");
    setOtp4("");
    setOtp5("");
    setOtp6("");
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { maxLength, value, name } = e.target;
    const fieldArr = name.split("-");
    const fieldIndex = fieldArr[1];
    const fieldIntIndex = parseInt(fieldIndex, 10);

    if (value.length >= maxLength) {
      if (fieldIntIndex < 6) {
        const nextfield: any = document.querySelector(
          `input[name=field-${fieldIntIndex + 1}]`,
        );
        if (nextfield !== null) {
          nextfield.focus();
        }
      }
    }

    if (value.length <= 0) {
      if (fieldIntIndex > 1) {
        const nextfield: any = document.querySelector(
          `input[name=field-${fieldIntIndex - 1}]`,
        );
        if (nextfield !== null) {
          nextfield.focus();
        }
      }
    }
  };
  const isDisabled = !otp1 || !otp2 || !otp3 || !otp4 || !otp5 || !otp6;
  return (
    <div className="w-full flex flex-col gap-[24px]">
      <div
        style={{ color: colors.dark }}
        className="text-[14px] md:text-[18px] font-[400] leading-normal"
      >
        Please enter the 6 digit code sent to <br />
        <b>{doctor?.email}</b>
      </div>

      <div className="flex w-full justify-between">
        <input
          name="field-1"
          value={otp1}
          maxLength={1}
          onChange={(e) => {
            handleChange(e);
            setOtp1(e.target.value);
          }}
          className="text-center w-[40px]  md:w-[60px] py-[10px] md:py-[20px]  mr-3 border rounded-[7px] mt-2"
          style={{
            borderWidth: "1px",
            borderColor: colors.dark,
            outline: colors.primary,
          }}
        />
        <input
          name="field-2"
          maxLength={1}
          value={otp2}
          onChange={(e) => {
            handleChange(e);
            setOtp2(e.target.value);
          }}
          className="text-center w-[40px]  md:w-[60px] py-[10px] md:py-[20px] mr-3 border rounded-[7px] mt-2"
          style={{
            borderWidth: "1px",
            borderColor: colors.dark,
            outline: colors.primary,
          }}
        />
        <input
          name="field-3"
          maxLength={1}
          value={otp3}
          onChange={(e) => {
            handleChange(e);
            setOtp3(e.target.value);
          }}
          className="text-center w-[40px]  md:w-[60px] py-[10px] md:py-[20px] mr-3 border rounded-[7px] mt-2"
          style={{
            borderWidth: "1px",
            borderColor: colors.dark,
            outline: colors.primary,
          }}
        />
        <input
          name="field-4"
          maxLength={1}
          value={otp4}
          onChange={(e) => {
            handleChange(e);
            setOtp4(e.target.value);
          }}
          className="text-center w-[40px]  md:w-[60px] py-[10px] md:py-[20px] mr-3 border rounded-[7px] mt-2"
          style={{
            borderWidth: "1px",
            borderColor: colors.dark,
            outline: colors.primary,
          }}
        />
        <input
          name="field-5"
          maxLength={1}
          value={otp5}
          onChange={(e) => {
            handleChange(e);
            setOtp5(e.target.value);
          }}
          className="text-center w-[40px]  md:w-[60px] py-[10px] md:py-[20px] mr-3 border rounded-[7px] mt-2"
          style={{
            borderWidth: "1px",
            borderColor: colors.dark,
            outline: colors.primary,
          }}
        />
        <input
          name="field-6"
          maxLength={1}
          value={otp6}
          onChange={(e) => {
            handleChange(e);
            setOtp6(e.target.value);
          }}
          className="text-center w-[40px]  md:w-[60px] py-[10px] md:py-[20px] border rounded-[7px] mt-2"
          style={{
            borderWidth: "1px",
            borderColor: colors.dark,
            outline: colors.primary,
          }}
        />
      </div>

      <Button
        className="w-full rounded-md"
        text="Verify your account"
        theme="primary"
        onClick={() => {
          if (!doctor?._id) {
            alert("Doctor information is missing. Cannot verify OTP.");
            return;
          }
          mutate(
            {
              doctorId: doctor._id,
              otp: otp1 + otp2 + otp3 + otp4 + otp5 + otp6,
            },
            {
              onSuccess: (data) => {
                setModalOpen(true);
              },
              onError: (error: any) => {
                const errorMessage =
                  error?.response?.data?.message ||
                  "OTP verification failed. Please try again.";
                customToast(errorMessage, ToastType.error);
              },
            },
          );
        }}
        disabled={isDisabled || !doctor?._id}
        loading={isPending}
      />
      <Button
        className="w-full rounded-md"
        text="Resend code"
        theme="tertiary-primary"
        onClick={handleResendCode}
        loading={isResending}
        disabled={!doctor?._id}
      />
    </div>
  );
};

export default EmailVerification;
